import { render } from "./arki-request-card-view.vue?vue&type=template&id=115de746"
import script from "./arki-request-card-view.vue?vue&type=script&setup=true&lang=js"
export * from "./arki-request-card-view.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/arki/views/request/arki-request-card-view.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "115de746"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('115de746', __exports__)) {
    api.reload('115de746', __exports__)
  }
  
  module.hot.accept("./arki-request-card-view.vue?vue&type=template&id=115de746", () => {
    api.rerender('115de746', render)
  })

}


export default __exports__